export default "__VITE_ASSET__82403589__"